import { environment } from 'src/environments/environment'
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms'
import { Observable, of } from 'rxjs'
import {
  catchError,
  distinctUntilChanged,
  filter,
  map,
  take,
  timeout
} from 'rxjs/operators'
import { AccessRights } from 'src/app/features/role/user-role/user-role'
import { Store } from '@ngrx/store'
import { configurationOptionSelectors } from '../../configuration-option.selectors'
import { ConfigurationOptionService } from '../../configuration-option.service'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { Actions, ofType } from '@ngrx/effects'
import { configurationOptionActions } from '../../configuration-option.actions'
import { NotificationService } from 'src/app/core/notification.service'

@UntilDestroy()
@Component({
  selector: 'configuration-option-product-branding-card',
  templateUrl: './product-branding-card.component.html',
  styleUrls: ['./product-branding-card.component.scss']
})
export class ConfigurationOptionProductBrandingCardComponent implements OnInit {
  public form: UntypedFormGroup
  @Input() isCollapsed: any = false
  //public isCollapsed = false
  @Output() onSubmit = new EventEmitter<any>()
  public formValues$: Observable<any>
  public accessRights = AccessRights
  public availableLanguages = environment.frontendLanguages.reduce(
    (acc, curr) => {
      if (curr != 'xx') return (acc[curr] = true), acc
      else return acc
    },
    {}
  )

  constructor(
    private fb: UntypedFormBuilder,
    private store: Store,
    private actions$: Actions,
    private notificationService: NotificationService,
    private configOptionService: ConfigurationOptionService
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      supervisorDisplayNameNl: [],
      supervisorDisplayNameEn: [],
      supervisorDisplayNameFr: [],
      supervisorDisplayNameDe: [],
      showOnlyFirstName: [],
      showFirstAndLastName: []
    })

    this.formValues$ = this.store
      .select(configurationOptionSelectors.selectAll)
      .pipe(
        distinctUntilChanged((a, b) => JSON.stringify(a) == JSON.stringify(b)),
        map((configOptions) =>
          this.configOptionService.mapEntitiesToObject(configOptions)
        )
      )

    this.formValues$
      .pipe(
        filter(
          (formValues) =>
            formValues?.supervisor_display_name &&
            formValues?.supervisor_display_name_option
        ),
        untilDestroyed(this)
      )
      .subscribe((formValues) => {
        if (formValues?.supervisor_display_name) {
          const values = JSON.parse(formValues.supervisor_display_name)
          this.form?.patchValue({
            supervisorDisplayNameNl: values.supervisor_display_name_nl,
            supervisorDisplayNameEn: values.supervisor_display_name_en,
            supervisorDisplayNameFr: values.supervisor_display_name_fr,
            supervisorDisplayNameDe: values.supervisor_display_name_de
          })
        }

        if (formValues?.supervisor_display_name_option) {
          const values = JSON.parse(formValues.supervisor_display_name_option)

          this.form?.patchValue({
            showOnlyFirstName: values.show_only_first_name,
            showFirstAndLastName: values.show_first_and_last_name
          })
        }
      })
  }

  public onInputChange(formFieldName: string, isChecked: boolean) {
    switch (formFieldName) {
      case 'showOnlyFirstName':
        if (isChecked) {
          this.form.controls['showFirstAndLastName'].patchValue(false)
        }
        break
      case 'showFirstAndLastName':
        if (isChecked) {
          this.form.controls['showOnlyFirstName'].patchValue(false)
        }
        break
    }
  }

  public onFormSubmit() {
    if (!this.form.valid) {
      return
    }

    const {
      supervisorDisplayNameNl,
      supervisorDisplayNameEn,
      supervisorDisplayNameFr,
      supervisorDisplayNameDe,
      showOnlyFirstName,
      showFirstAndLastName
    } = this.form.controls

    const form = this.form.value

    form['supervisor_display_name'] = JSON.stringify({
      supervisor_display_name_nl: supervisorDisplayNameNl.value,
      supervisor_display_name_en: supervisorDisplayNameEn.value,
      supervisor_display_name_fr: supervisorDisplayNameFr.value,
      supervisor_display_name_de: supervisorDisplayNameDe.value
    })
    form['supervisor_display_name_option'] = JSON.stringify({
      show_only_first_name: showOnlyFirstName.value ?? false,
      show_first_and_last_name: showFirstAndLastName.value ?? false
    })

    delete form.supervisorDisplayNameNl
    delete form.supervisorDisplayNameEn
    delete form.supervisorDisplayNameFr
    delete form.supervisorDisplayNameDe
    delete form.showOnlyFirstName
    delete form.showFirstAndLastName
    this.actions$
      .pipe(
        ofType(
          configurationOptionActions.upsertMany,
          configurationOptionActions.updateOneById,
          configurationOptionActions.upsertOne
        ),
        take(1),
        timeout(2000),
        catchError((error) => of(null))
      )
      .subscribe((action) =>
        action
          ? this.notificationService.emit('alerts.success', 'success')
          : null
      )
    this.configOptionService.updateOrCreateMany(form)
  }
}
